import { getColorVariable } from "@components/common/utils/helper";
import { type CloseProps } from "./close";
import { KeyValueObject } from "@components/common/types/general";

export function getSize(size: CloseProps["size"], theme: any): KeyValueObject {
    if (size === "sm") {
        return { width: theme.spacing[4], height: theme.spacing[4] };
    }
    if (size === "lg") {
        return { width: theme.spacing[10], height: theme.spacing[10] };
    }
    return { width: theme.spacing[6], height: theme.spacing[6] };
}

export function getColor(color: CloseProps["color"], background: CloseProps["background"], theme: any): KeyValueObject {
    if (!background) {
        return {
            color: getColorVariable(color, theme, {
                gray: theme.colors.gray[300],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
        };
    }
    return { color: theme.colors.white };
}

export function getBackgroundColor(color: CloseProps["color"], background: CloseProps["background"], theme: any): KeyValueObject | null {
    if (background) {
        return {
            backgroundColor: getColorVariable(color, theme, {
                gray: theme.colors.gray[300],
                white: theme.colors.white,
                colorize: theme.colors[color || "primary"][500],
                default: theme.colors.gray[950],
            }),
        };
    }
    return null;
}

export function getSpanBackgroundColor(color: CloseProps["color"], background: CloseProps["background"], theme: any): KeyValueObject {
    if (background) {
        if (color === "white") {
            return { backgroundColor: theme.colors.gray[950] };
        }
        return { backgroundColor: theme.colors.white };
    }
    return {
        backgroundColor: getColorVariable(color, theme, {
            gray: theme.colors.gray[300],
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][500],
            default: theme.colors.gray[950],
        }),
    };
}

export function getScaleOnHover(size: CloseProps["size"]): KeyValueObject | null {
    if (size === "lg") {
        return { scale: "125%" };
    }
    if (!size) {
        return { scale: "90%" };
    }
    return null;
}
